/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ComputeReason = {
  code: string;
  details?: { [k: string]: any } | undefined;
  message: string;
};

/** @internal */
export const ComputeReason$inboundSchema: z.ZodType<
  ComputeReason,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  details: z.record(z.any()).optional(),
  message: z.string(),
});
/** @internal */
export type ComputeReason$Outbound = {
  code: string;
  details?: { [k: string]: any } | undefined;
  message: string;
};

/** @internal */
export const ComputeReason$outboundSchema: z.ZodType<
  ComputeReason$Outbound,
  z.ZodTypeDef,
  ComputeReason
> = z.object({
  code: z.string(),
  details: z.record(z.any()).optional(),
  message: z.string(),
});

export function computeReasonToJSON(computeReason: ComputeReason): string {
  return JSON.stringify(ComputeReason$outboundSchema.parse(computeReason));
}
export function computeReasonFromJSON(
  jsonString: string,
): SafeParseResult<ComputeReason, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeReason$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeReason' from JSON`,
  );
}
